import React, { FC } from "react";
import { IDamsList, ISummaryControlMeasureAdequacy, ISocietalRisk, ISummaryControlMeasureAssessment, dataEntry, IDataTest } from "../../types/types";
import { Accordion, AccordionSummary, Grid, Paper } from "@material-ui/core";
import BarChart from "./bar";
import DamHeatMap from "./dam_heat_map";
import { ExpandMore } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Map from "./map";
import PieChart from "./pie";
import { trafficLight } from "../../theme";
import SoKInfo from "./sok_infobar";
import NoDamInfo from "./no_dam";
import HeatMapTable from "./heat_map_table";
import HeatMapTableCM from "./heat_map_table_CM";
import HeatMapTableCM2 from "./heat_map_table_CM2";
import { number } from "echarts";

interface IControlProps {
    controlMeasures: ISummaryControlMeasureAdequacy[],
    controlMeasureAssessments: ISummaryControlMeasureAssessment[],
    damList: IDamsList[],
    assessments_filtered: number[],
    risk_assessments: ISocietalRisk[]
}


const ControlMeasures: FC<IControlProps> = ({ controlMeasures, controlMeasureAssessments, damList, assessments_filtered, risk_assessments }) => {

    const filtered_control_measures: Array<ISummaryControlMeasureAdequacy> = []
    const filtered_control_measure_assessments: Array<ISummaryControlMeasureAssessment> = []

    // for each of the assessment project ids
    const elements = assessments_filtered.map(id => {
        // filter the control measures for the given assessment project id
        const filtered1 = controlMeasures.filter(s => s.assessment_project_id === id)
        const filtered2 = controlMeasureAssessments.filter(s => s.assessment_project_id === id)
        // push the filtered control measures to the filtered control measures array
        filtered1.forEach(element => filtered_control_measures.push(element))
        filtered2.forEach(element => filtered_control_measure_assessments.push(element))
    })

    let anyDams = false

    if (filtered_control_measures.length > 0) {
        anyDams = true
    }




    // this function takes an assement id and returns the number of opportunities
    // to improve critical failure modes for each catergory
    const get_data = (assessment_id: number) => {

        const assessments = filtered_control_measures.filter(s => s.assessment_project_id === assessment_id)

        const sub = assessments.map(a => {

            // set level to 5 if undefined else set level to the value
            let level = 5
            if (a.improvement_adequacy !== null) {
                level = a.improvement_adequacy.level
            }
            return level
        })

        const very_weak = sub.filter(s => s === 4).length
        const weak = sub.filter(s => s === 3).length
        const moderate = sub.filter(s => s === 2).length
        const strong = sub.filter(s => s === 1).length
        const undefined = sub.filter(s => s === 5).length

        return [very_weak, weak, moderate, strong, undefined]

    }

    // this maps over all assment ids and prepares the data
    // for input into the heat map
    const heat_map_data: any[][] = assessments_filtered.map(a_id => {
        const init_data = get_data(a_id)
        const name = damList.find(d => d.id === a_id)?.dam.name

        //randomly generate a number between 1 and 1000

        let soc_level: any = risk_assessments.filter(dam => dam.assessment_project_id === a_id)

        // there is the potential for a dam to not have any data
        let societal_risk_value: number | string = 0
        if (soc_level.length > 0) {
            let societal_risk_value_number = soc_level[0].societal_risk_before
            // societal_risk_value = 
            societal_risk_value = societal_risk_value_number.toExponential(2)

        }

        const data = init_data.map((d, i) => {
            return [i + 1, d]
        })

        return [name, societal_risk_value, ...data]
    })


    const pie_summary_improvements = () => {

        let vw = 0
        let w = 0
        let m = 0
        let s = 0
        let u = 0

        assessments_filtered.forEach(a_id => {
            const data = get_data(a_id)
            vw += data[0]
            w += data[1]
            m += data[2]
            s += data[3]
            u += data[4]
        })

        return {
            title: `Opportunity to improve controls by critical failure modes`,
            description: ["Individual Risk Confidence", "Societal Confidence"],
            data: [{ name: 'Very Weak', value: [vw] },
            { name: 'Weak', value: [w] },
            { name: 'Moderate', value: [m] },
            { name: 'Strong', value: [s] },
            { name: 'Undefined', value: [u] }],
            colour: {
                background: [trafficLight.cmgreen, trafficLight.cmyellow, trafficLight.cmorange, trafficLight.cmred, trafficLight.grey],
                font: [trafficLight.green, trafficLight.yellow, trafficLight.cmdorange, trafficLight.cmred, trafficLight.dgrey]
            },
            height: 375
        }
    }


    const pie_summary_assessments = () => {

        let rp = 0
        let rpt = 0
        let npt = 0
        let np = 0
        let u = 0

        assessments_filtered.forEach(a_id => {
            const data = get_data_assessment(a_id)

            rp += data[0][1]
            rpt += data[1][1]
            npt += data[2][1]
            np += data[3][1]
            u += data[4][1]
        })

        return {

            title: `Reasonably Practicable assessment of additional controls \n by failure modes`,
            description: ["Individual Risk Confidence", "Societal Confidence"],
            data: [{ name: 'RP', value: [rp] },
            { name: 'RP (Tentative)', value: [rpt] },
            { name: 'NRP (Tentative)', value: [npt] },
            { name: 'NRP', value: [np] },
            { name: 'Cannot Determine', value: [u] }],
            colour: {
                background: [trafficLight.cmred, trafficLight.cmorange, trafficLight.cmyellow, trafficLight.cmgreen, trafficLight.grey],
                font: [trafficLight.cmred, trafficLight.cmdorange, trafficLight.yellow, trafficLight.green, trafficLight.dgrey]

            },
            height: 375
        }
    }

    // this function get the data for the pie chart
    const get_data_pie = (): IDataTest<dataEntry> => {

        // for th list of the number of each type of opportunity (weak,mod etc.)
        // find the last non zero data entry and the index of this is the worst
        //case level of for the dam
        const pie_data = assessments_filtered.map(a_id => {
            const init_data = get_data(a_id)
            let max = 0
            init_data.forEach((d, i) => {

                if (d !== 0) {
                    max = i + 1
                }
            })
            return max

        })

        return {
            title: `Opportunity to improve controls by dam`,
            description: ["Individual Risk Confidence", "Societal Confidence"],
            data: [{ name: 'Very Weak', value: [pie_data.filter(d => d === 1).length] },
            { name: 'Weak', value: [pie_data.filter(d => d === 2).length] },
            { name: 'Moderate', value: [pie_data.filter(d => d === 3).length] },
            { name: 'Strong', value: [pie_data.filter(d => d === 4).length] },
            { name: 'Undefined', value: [pie_data.filter(d => d === 5 || d === 0).length] }],
            colour: {
                background: [trafficLight.cmgreen, trafficLight.cmyellow, trafficLight.cmorange, trafficLight.cmred, trafficLight.grey],
                font: [trafficLight.green, trafficLight.yellow, trafficLight.cmdorange, trafficLight.cmred, trafficLight.dgrey]
            },
            height: 375

        }
    }

    // this function get the data for the pie chart
    const get_data_pie_assessments = (): IDataTest<dataEntry> => {

        // for th list of the number of each type of opportunity (weak,mod etc.)
        // find the last non zero data entry and the index of this is the worst
        //case level of for the dam
        const pie_data = assessments_filtered.map(a_id => {
            const init_data = get_data_assessment(a_id).reverse()
            let max = 0
            init_data.forEach((d, i) => {

                if (d[1] !== 0) {
                    max = i + 1
                }
            })
            return max

        })

        return {
            title: `Reasonably Practicable assessment of additional controls \n by failure modes by dam`,
            description: ["Individual Risk Confidence", "Societal Confidence"],
            data: [{ name: 'RP', value: [pie_data.filter(d => d === 5).length] },
            { name: 'RP (Tentative)', value: [pie_data.filter(d => d === 4).length] },
            { name: 'NRP (Tentative)', value: [pie_data.filter(d => d === 3).length] },
            { name: 'NRP', value: [pie_data.filter(d => d === 2).length] },
            { name: 'Cannot Determine', value: [pie_data.filter(d => d === 1).length] }],
            colour: {
                background: [trafficLight.cmred, trafficLight.cmorange, trafficLight.cmyellow, trafficLight.cmgreen, trafficLight.grey],
                font: [trafficLight.cmred, trafficLight.cmdorange, trafficLight.yellow, trafficLight.green, trafficLight.dgrey]
            },
            height: 375

        }
    }


    // this funtion prepares the data for use in a assesment heat map for each assessment id

    const get_data_assessment = (assessment_id: number) => {

        const assessments = filtered_control_measure_assessments.filter(s => s.assessment_project_id === assessment_id && s.considered === true && s.overall_assessment_id !== null)

        // get a list of all the control_measure ids
        const control_measure_ids = Array.from(new Set(assessments.map(a => {

            if (a.considered === true) {
                return a.control_measure_id

            }

        })))

        // for each of the control_measure ids find the lowest level
        const sub = control_measure_ids.map(id => {

            const list = assessments.filter(s => s.control_measure_id === id)

            const level = Math.min(...list.map(a => a.overall_assessment_id))

            return level
        })

        const rp = sub.filter(s => s === 1).length
        const rpt = sub.filter(s => s === 2).length
        const npt = sub.filter(s => s === 3).length
        const np = sub.filter(s => s === 4).length
        const undefined = sub.filter(s => s === 5).length

        return [[1, rp], [2, rpt], [3, npt], [4, np], [5, undefined]]


    }

    const assessment_hm_data: any[][] = assessments_filtered.map(a_id => {
        const init_data = get_data_assessment(a_id)
        const name = damList.find(d => d.id === a_id)?.dam.name

        // get the societal level data for the dam
        //randomly generate a number between 1 and 1000
        let soc_level: any = risk_assessments.filter(dam => dam.assessment_project_id === a_id)

        // there is the potential for a dam to not have any data
        let societal_risk_value: number | string = 0
        if (soc_level.length > 0) {
            let societal_risk_value_number = soc_level[0].societal_risk_before
            societal_risk_value = societal_risk_value_number.toExponential(2)
        }

        return [name, societal_risk_value, ...init_data]
    })



    //sort data by societal impact
    assessment_hm_data.sort((a, b) => {
        return b[1] - a[1]
    })

    assessment_hm_data.forEach(d => {
        if (d[1] === 0) {
            d[1] = 'Undefined'
        }
    })


    heat_map_data.sort((a, b) => {
        return b[1] - a[1]
    })

    heat_map_data.forEach(d => {
        if (d[1] === 0) {
            d[1] = 'Undefined'
        }
    })





    return (
        <>
            <Accordion>
                <AccordionSummary id={"1"} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> Summary </Typography>
                </AccordionSummary>
                <Typography>
                    <Grid container spacing={3} xl={12} direction="row">
                        {(<>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div style={{ padding: "10px" }}>
                                    <Paper variant={"outlined"} style={{ textAlign: 'left', padding: '10px' }}>

                                        The pie charts shown below are groups as follows:<br />
                                        <ul>
                                            <li><b>Opportunity to improve controls by dam:</b> Dams are grouped by their critical failure mode that has the greatest opportunity for imporvement. </li>
                                            <li><b>Reasonably Practicable assessment of additional controls by failure modes by dam:</b> Dams are grouped by their control measure that is most practicable. </li>

                                        </ul>
                                        Some abbreviations have been taken foward in the charts and tables below:
                                        <ul>
                                            <li>Reasonably Practicable: (RP)</li>
                                            <li>Reasonably Practicable (Tentative): RP (Tentative) </li>
                                            <li>Not Reasonably Practicable (Tentative): NRP (Tentative) </li>
                                            <li>Not Reasonably Practicable: NRP</li>
                                            <li>Cannot Determine at this Time: Cannot Determine</li>
                                        </ul>

                                    </Paper>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <PieChart data={get_data_pie()} />
                                    : <NoDamInfo />}

                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <PieChart data={get_data_pie_assessments()} />
                                    : <NoDamInfo />}
                            </Grid>
                        </>)}

                    </Grid>
                </Typography>
            </Accordion>
            <Accordion>
                <AccordionSummary id={"1"} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> Detail </Typography>
                </AccordionSummary>
                <Typography>
                    <Paper variant={"outlined"} style={{ textAlign: 'left', padding: '10px' }}>

                        The pie charts shown below are groups as follows:<br />
                        <ul>
                            <li><b>Opportunity to improve controls by critical failure modes:</b> Grouped by the total number of critical failure modes across all filtered dams </li>
                            <li><b>Reasonably Practicable assessment of additional controls by failure modes:</b> Grouped by the total number of control measure assessments across all filtered dams. </li>

                        </ul>


                    </Paper>
                    <Grid container spacing={3} xl={12} direction="row">
                        {(<>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <PieChart data={pie_summary_improvements()} />
                                    : <NoDamInfo />}

                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <PieChart data={pie_summary_assessments()} />
                                    : <NoDamInfo />}

                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <HeatMapTableCM controlMeasures={heat_map_data} />
                                    : <NoDamInfo />}

                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                {anyDams
                                    ? <HeatMapTableCM2 controlMeasures={assessment_hm_data} />
                                    : <NoDamInfo />}

                            </Grid>
                        </>)}

                    </Grid>
                </Typography>
            </Accordion>
        </>
    )



}

export default ControlMeasures